let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1SJVO")).then(() => parcelRequire('4WYo7'));